/**
 * Turns a working-day window into an estimated delivery date range
 * ("Estimated delivery Tue 24 Sep – Thu 26 Sep"), skipping weekends.
 * The server renders a plain "5–7 working days" fallback in the same slot.
 */
function addWorkingDays(start, days) {
  const date = new Date(start);
  let added = 0;
  while (added < days) {
    date.setDate(date.getDate() + 1);
    const day = date.getDay();
    if (day !== 0 && day !== 6) added += 1;
  }
  return date;
}

class CrEta extends HTMLElement {
  connectedCallback() {
    const min = Number(this.dataset.min);
    const max = Number(this.dataset.max);
    const target = this.querySelector('[ref="text"]');
    if (!target || !Number.isFinite(min) || !Number.isFinite(max)) return;

    // Plain "en" formats US-style ("Fri, Oct 16"); this store is Irish, so prefer en-IE ("Fri 16 Oct").
    const htmlLang = document.documentElement.lang || 'en';
    const lang = htmlLang === 'en' ? 'en-IE' : htmlLang;
    const format = new Intl.DateTimeFormat(lang, { weekday: 'short', day: 'numeric', month: 'short' });
    const now = new Date();
    const from = format.format(addWorkingDays(now, min));
    const to = format.format(addWorkingDays(now, max));
    const label = this.dataset.label || 'Estimated delivery';
    target.textContent = min === max ? `${label} ${from}` : `${label} ${from} – ${to}`;
  }
}

if (!customElements.get('cr-eta')) customElements.define('cr-eta', CrEta);
